
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisationOptions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessAccreditedSuppliers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowIndividualsParticipation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowReturnTenderToSite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableBudgetType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelTenderAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bidStepType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blackListMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criteriaCardsAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysWebTender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deleteBidAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryAddressAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editEndTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideBestPriceBeforeBidding"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"includeVat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxBidStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumLotsCountPerTender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minBidStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offerToGoToTender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceConfirmationSendAllowed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reasonChangeChoice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sendPrivateMessageToBidderAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suplierAddressAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAllowParticipantCancelBid"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":610}};
    doc.loc.source = {"body":"query {\n  organisationOptions{\n    accessAccreditedSuppliers\n    allowIndividualsParticipation\n    allowReturnTenderToSite\n    availableBudgetType\n    cancelTenderAvailable\n    bidStepType\n    blackListMode\n    criteriaCardsAvailable\n    daysWebTender\n    deleteBidAvailable\n    deliveryAddressAvailable\n    editEndTime\n    hideBestPriceBeforeBidding\n    includeVat\n    maxBidStep\n    maximumLotsCountPerTender\n    minBidStep\n    offerToGoToTender\n    priceConfirmationSendAllowed\n    reasonChangeChoice\n    sendPrivateMessageToBidderAvailable\n    suplierAddressAvailable\n    isAllowParticipantCancelBid\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
